<template>
<div id="top">
  <div class>
  <ViewSpecies :animal="'bird'"/>
  </div>
</div>
</template>

<script>
import ViewSpecies from "../components/ViewSpecies.vue"

export default {
  name: 'Birds',
  components: {
    ViewSpecies,
  },
}
</script>
